<div class="text" *ngIf="categories$ | async as categories">
  Work Order would be created
  <ng-container *ngIf="pmsType">
    in
    <span class="bold">{{ pmsType | pmsTypeEnumeration | async }}&nbsp;</span>
  </ng-container>
  <ng-container *ngIf="origin || categoryId || topicId">with&nbsp;</ng-container>
  <!-- prettier-ignore -->
  <ng-container *ngIf="origin">origin: <span class="bold">{{ origin }}&nbsp;</span></ng-container>

  <ng-container *ngIf="categories?.length && (categoryId || topicId)">
    <ng-container *ngIf="origin">and&nbsp;</ng-container>
    <!-- prettier-ignore -->
    <ng-container *ngIf="categoryId">category: <span class="bold">{{ categoryId | ticketCategoryTopicName: categories }}</span>&nbsp;</ng-container>
    <ng-container *ngIf="topicId">and&nbsp;</ng-container>
    <!-- prettier-ignore -->
    <ng-container *ngIf="topicId">subcategory: <span class="bold">{{ topicId | ticketCategoryTopicName: categories:true }}</span>
    </ng-container>
  </ng-container>
</div>
